import { RegisterOptions } from "react-hook-form";
import { validateCharacterLength } from "../../utils/utils";
import { WASTE_VALIDATION, WASTE_VALIDATION_MESSAGES } from "./wasteManagement.constants";

export const validateWasteStreamName = (value: string) =>
  validateCharacterLength(
    value,
    WASTE_VALIDATION.MAX_STREAM_NAME_LENGTH,
    WASTE_VALIDATION_MESSAGES.STREAM_NAME_TOO_LONG
  );

export const WASTE_STREAM_NAME_RULES: RegisterOptions = {
  validate: { streamNameLength: validateWasteStreamName }
};

export const validateMoistureRange = (value: string | undefined): true | string => {
  if (!value || value === "") return true;
  const num = parseFloat(value);
  if (isNaN(num)) return true;
  if (num < WASTE_VALIDATION.MIN_MOISTURE_PERCENT) return "Must be 0 or greater";
  if (num > WASTE_VALIDATION.MAX_MOISTURE_PERCENT) return "Cannot exceed 100%";
  return true;
};

export const MOISTURE_CONTENT_RULES: RegisterOptions = {
  validate: { moistureRange: validateMoistureRange }
};
